import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React from 'react';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description: Navigation button with icon optional: cancel, previous, or other.
 * @param String id: Button identifier (required).
 * @param String url: Navigation URL (optional).
 * @param event click: Click event (required).
 * @param String text Title button (required).
 * @param Boolean disabled: Variable to disable the button (required).
 * @param {JSX.Element} Icon: Icon component (optional).
 * @param String className: Two style classes for the icon, one for size and another for color, or default styles initialized
 * @param Boolean uppercase: If true, change text button to uppercase
 * @returns {JSX.Element}
 */
export const ButtonPrevStep = ({ id, url, click = null, text = "", disabled = false , Icon,
                                   classNameBtn='', className='btn-icon-svg-20px btn-icon-svg-red', uppercase=false }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return <button
        id={id}
        disabled={disabled}
        onClick={() => {
            if (click !== null) click();
            if(url) navigate(url)
        }}
        className={`btn-prev-step ${classNameBtn}`}
    >
        {Icon ?
            <div className={'d-flex justify-content-between align-items-center w-100'}>
                <span className="ibl-font-w-600">{uppercase ? t(text).toUpperCase() :t(text)}</span>
                <Icon className={className} />
            </div>
            :
            <span className="ibl-font-w-600">{uppercase ? t(text).toUpperCase() :t(text)}</span>
        }
    </button>
}

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description: Navigation button with icon optional: next, create, update or other.
 * @param String id: Button identifier (required).
 * @param String url: Navigation URL (optional).
 * @param event click: Click event (required).
 * @param String text Title button (required).
 * @param Boolean disabled: Variable to disable the button (required).
 * @param {JSX.Element} Icon: Icon component (optional).
 * @param String className: Two style classes for the icon, one for size and another for color, or default styles initialized
 * @param Boolean uppercase: If true, change text button to uppercase
 * @param Boolean iconBetween: If true, Place the button justified within the div; otherwise, it aligns them to the center.
 * @returns {JSX.Element}
 */
export const ButtonNextStep = ({ id, url, click = null, text = "", disabled = false, Icon, iconBetween=true,
                                   className='btn-next-step', classNameIcon='btn-icon-svg-20px btn-icon-svg-white', uppercase=false}) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return <button
        id={id}
        disabled={disabled}
        onClick={(e) => {
            if (click !== null) click(e);
            if(url) navigate(url);
        }}
        className={`${className}`}
    >
        {Icon ?
            <div className={`${iconBetween ? 'd-flex justify-content-between align-items-center w-100' : 'd-flex align-items-center justify-content-center gap-2' }`}>
                <span className="">{uppercase ? t(text).toUpperCase(): t(text)}</span>
                <Icon className={classNameIcon} />
            </div>
            :
            <span className="">{uppercase ? t(text).toUpperCase() :t(text)}</span>
        }
    </button>
}


export const ButtonAddRule = ({ id, url, click = null, text = "", disabled = false, Icon, className='btn-icon-svg-20px btn-icon-svg-white'}) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return <button
        id={id}
        disabled={disabled}
        onClick={(e) => {
            if (click !== null) click(e);
            if(url) navigate(url);
        }}
        className={ "btn-add-rule"}
    >
        {Icon ?
            <div className={'d-flex justify-content-between align-items-center w-100'}>
                <span className="">{t(text)}</span>
                <Icon className={className} />
            </div>
            :
            <span className="">{t(text)}</span>
        }
    </button>
}
